import { render, staticRenderFns } from "./SkupTemaDetails.vue?vue&type=template&id=7fb9d960&scoped=true&"
import script from "./SkupTemaDetails.vue?vue&type=script&lang=js&"
export * from "./SkupTemaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb9d960",
  null
  
)

export default component.exports